export const DEFAULT_BILLED_ANNUALLY = true;
